enum UpgradeIds {
	// Upgrades Update 1
	EscExponent1,
	EscExponent2,
	EscExponent3,
	EscExponent4,
	EscExponent5,
	EscExponent6,
	EscExponent7,
	SwmExponent1,
	SwmExponent2,
	SwmExponent3,
	SwmExponent4,
	SwmExponent5,
	SwmExponent6,
	SwmExponent7,
	CccExponent1,
	CccExponent2,
	CccExponent3,
	CccExponent4,
	CccExponent5,
	CccExponent6,
	CccExponent7,
	PalExponent1,
	PalExponent2,
	PalExponent3,
	PalExponent4,
	PalExponent5,
	PalExponent6,
	PalExponent7,
	FgrExponent1,
	FgrExponent2,
	FgrExponent3,
	FgrExponent4,
	FgrExponent5,
	FgrExponent6,
	FgrExponent7,
	MefExponent1,
	MefExponent2,
	MefExponent3,
	MefExponent4,
	MefExponent5,
	MefExponent6,
	MefExponent7,
	SpcExponent1,
	SpcExponent2,
	SpcExponent3,
	SpcExponent4,
	SpcExponent5,
	SpcExponent6,
	SpcExponent7,
	PdmExponent1,
	PdmExponent2,
	PdmExponent3,
	PdmExponent4,
	PdmExponent5,
	PdmExponent6,
	PdmExponent7,
	CbaExponent1,
	CbaExponent2,
	CbaExponent3,
	CbaExponent4,
	CbaExponent5,
	CbaExponent6,
	CbaExponent7,
	LcrExponent1,
	LcrExponent2,
	LcrExponent3,
	LcrExponent4,
	LcrExponent5,
	LcrExponent6,
	LcrExponent7,
	PrsExponent1,
	PrsExponent2,
	PrsExponent3,
	PrsExponent4,
	PrsExponent5,
	PrsExponent6,
	PrsExponent7,
	SmbExponent1,
	SmbExponent2,
	SmbExponent3,
	SmbExponent4,
	SmbExponent5,
	SmbExponent6,
	SmbExponent7,
	FnnExponent1,
	FnnExponent2,
	FnnExponent3,
	FnnExponent4,
	FnnExponent5,
	FnnExponent6,
	FnnExponent7,
	DmfExponent1,
	DmfExponent2,
	DmfExponent3,
	DmfExponent4,
	DmfExponent5,
	DmfExponent6,
	DmfExponent7,
	ElmExponent1,
	ElmExponent2,
	ElmExponent3,
	ElmExponent4,
	ElmExponent5,
	ElmExponent6,
	ElmExponent7,
	EpaExponent1,
	EpaExponent2,
	EpaExponent3,
	EpaExponent4,
	EpaExponent5,
	EpaExponent6,
	EpaExponent7,
	SmnExponent1,
	SmnExponent2,
	SmnExponent3,
	SmnExponent4,
	SmnExponent5,
	SmnExponent6,
	SmnExponent7,
	DysExponent1,
	DysExponent2,
	DysExponent3,
	DysExponent4,
	DysExponent5,
	DysExponent6,
	DysExponent7,
	BrgExponent1,
	BrgExponent2,
	BrgExponent3,
	BrgExponent4,
	BrgExponent5,
	BrgExponent6,
	BrgExponent7,
	DsvExponent1,
	DsvExponent2,
	DsvExponent3,
	DsvExponent4,
	DsvExponent5,
	DsvExponent6,
	DsvExponent7,
	ClcExponent1,
	ClcExponent2,
	ClcExponent3,
	ClcExponent4,
	ClcExponent5,
	ClcExponent6,
	ClcExponent7,
	CtpExponent1,
	CtpExponent2,
	CtpExponent3,
	CtpExponent4,
	CtpExponent5,
	CtpExponent6,
	CtpExponent7,
	InaExponent1,
	InaExponent2,
	InaExponent3,
	InaExponent4,
	InaExponent5,
	InaExponent6,
	InaExponent7
}
enum UpgradeTypes {
	TwoExponentRise
}
export { UpgradeIds, UpgradeTypes }
